// honeymoon.js

const honeymoon = {
  id: 4,
  title: "Honeymoon Packages",
  questions: [
    {
      question: "Do you offer honeymoon packages?",
      answer:
        "Yes, we provide romantic honeymoon packages for both domestic and international destinations.",
    },
    {
      question: "Can honeymoon trips be customized?",
      answer:
        "Absolutely. We customize stays, activities, candlelight dinners, and experiences according to your preferences.",
    },
    {
      question: "Which honeymoon destinations are most popular?",
      answer:
        "Bali, Maldives, Switzerland, Thailand, Kashmir, and Kerala are among the most popular honeymoon destinations.",
    },
  ],
};

export default honeymoon;